// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PDPA_wrapper__sLC-q","content":"PDPA_content__sk9Yg","link":"PDPA_link__2RdEq","button":"PDPA_button__38B3A"};